import { createContext, useContext } from "react";
import type { AdminApi } from "../lib/api";

export const ApiContext = createContext<AdminApi | null>(null);

export function useAdminApi(): AdminApi {
  const ctx = useContext(ApiContext);
  if (!ctx) throw new Error("useAdminApi must be used within <ApiContext.Provider>");
  return ctx;
}
